import {
  DEMO_MAIN_SAVE_EVENT,
  DEMO_STEP_DELAY,
} from '../../playback-constants'
import { animateAction, wait } from '../../helpers'

type PlayMainStepParams = {
  controls: PlaybackControls
  fields: AnimatedField[]
  onComplete(): void
  stepElement: HTMLElement
}

export const playMainStep = async ({
  controls,
  fields,
  onComplete,
  stepElement,
}: PlayMainStepParams) => {
  const fieldsAreTyped = await controls.typeFields(fields)

  if (!fieldsAreTyped) {
    controls.clearFields(fields)
    return false
  }

  const action = stepElement.querySelector<HTMLElement>('[data-demo-playback-action="main"]')

  if (!action) {
    return false
  }

  await wait(DEMO_STEP_DELAY)
  await animateAction(action)

  if (!controls.dispatchEvent(new CustomEvent(DEMO_MAIN_SAVE_EVENT))) {
    return false
  }

  onComplete()
  await wait(DEMO_STEP_DELAY)

  return true
}
